import { Text, TextStyle, TextColor } from '@doordash/design-language';
import { initialFocusElementProps } from '../constants.js';
import ModalHeaderImage from './ModalHeaderImage.js';
import React from 'react';
import NavBar from '@doordash/component-navbar';
import { HeaderNavBarWrapper } from '../styles.js';
import { ModalCloseButtonSide } from '../types.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DefaultContentHeader = function DefaultContentHeader(_ref) {
  var closeButtonAccessibilityLabel = _ref.closeButtonAccessibilityLabel,
      closeButtonSide = _ref.closeButtonSide,
      headerAlignment = _ref.headerAlignment,
      headerImage = _ref.headerImage,
      hasCloseButton = _ref.hasCloseButton,
      hasContent = _ref.hasContent,
      hasFooter = _ref.hasFooter,
      hasPadding = _ref.hasPadding,
      isFullScreenOnMobile = _ref.isFullScreenOnMobile,
      onClose = _ref.onClose,
      subtitle = _ref.subtitle,
      subtitleId = _ref.subtitleId,
      subtitleSize = _ref.subtitleSize,
      title = _ref.title,
      titleId = _ref.titleId,
      titleSize = _ref.titleSize,
      useDynamicPadding = _ref.useDynamicPadding,
      useHairlineDividers = _ref.useHairlineDividers;
  var displayCloseButton = !headerImage && hasCloseButton;
  return /*#__PURE__*/React.createElement(React.Fragment, null, headerImage && /*#__PURE__*/React.createElement(ModalHeaderImage, {
    headerImage: headerImage,
    isFullScreenOnMobile: isFullScreenOnMobile
  }), /*#__PURE__*/React.createElement(HeaderNavBarWrapper, {
    noPadding: !hasPadding,
    useDynamicPadding: useDynamicPadding,
    removeBottomPadding: !hasContent && hasFooter && !useHairlineDividers
  }, /*#__PURE__*/React.createElement(NavBar, {
    allowSubtextWrapping: true,
    allowTitleWrapping: true,
    isSeparatorVisible: false,
    onNavigationClick: onClose,
    navigationAlignment: closeButtonSide === ModalCloseButtonSide.Trailing ? NavBar.NavigationAlignments.Trailing : NavBar.NavigationAlignments.Leading,
    navigationType: displayCloseButton ? NavBar.NavigationTypes.Close : NavBar.NavigationTypes.None,
    noContentPadding: true,
    shouldRenderTitleOnNewLine: closeButtonSide === ModalCloseButtonSide.Trailing ? false : true,
    strings: {
      navigationButtonLabel: closeButtonAccessibilityLabel
    },
    textAlign: headerAlignment,
    title: title ? /*#__PURE__*/React.createElement(Text, _extends({
      styles: TextStyle.NavBarExpandedTitle,
      size: titleSize,
      textAlign: headerAlignment,
      id: titleId
    }, initialFocusElementProps), title) : undefined,
    titleSize: NavBar.TitleSizes.Large
  }), subtitle && /*#__PURE__*/React.createElement(Text, {
    styles: TextStyle.NavBarExpandedSubtitle,
    color: TextColor.TextTertiary,
    size: subtitleSize,
    id: subtitleId,
    textAlign: headerAlignment
  }, subtitle)));
};

export { DefaultContentHeader as default };
